import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { addAction } from '@/redux/store/information';
import alert from '@/pages/components/common/alert';
import '../scss/index.scss';

class EditLink extends React.Component < any, any > {
    constructor(props: any) {
        super(props);
        this.state = {
            shop_domain: '',
        }
    }

    componentDidMount() {
        if ((this.props as any).shop_domain) {
            this.setState({
                shop_domain: (this.props as any).shop_domain,
            })
        }
    }

    render() {
        return (
            <div className="gray-bg">
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>店铺链接</label>
						<input
							type="text" 
							placeholder="请输入店铺链接" 
							className="text-right link-domain-input" 
							value={this.state.shop_domain}  
							onChange={ (e:any) => this.changeState('shop_domain', e.target.value) }/>
						
					</div>
				</div>
				<div className="link-box">
					<p>.cn.ibuychem.com</p>
				</div>
				<div className="default-btn-warrper">
					<button className="default-btn" onClick={() => this.submitForm()}>确定</button>
				</div>
			</div>
        )
    }

    private changeState(k: string, v: any) {
        const value = v.replace(/\s*/g, '');

        this.setState({
            [k]: value,
        })
    }
    // 更新state
    private changeInfoState(k: string, v: any) {
        (this.props as any).addAction({
            [k]: v
        })
    }

    private submitForm() {

        if (!this.state.shop_domain) {
            alert.open({
                promptText: '店铺链接不能为空！'
            })
            return;
        }

        this.changeInfoState('shop_domain', this.state.shop_domain);
        this.goForm();
    }

    private goForm() {
        (this.props as any).history.goBack(-1)
    }
}

const mapStateToProps = (state: any) => {
    return {
        ...state.storeInformationReducer
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ addAction }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EditLink);